import React, { ComponentPropsWithRef, createContext, useContext } from 'react'
import { BinRefs } from '../lib/types'

export type BinContextType = {
    selectedBinRef: BinRefs | null
    onSelectBin: (binRef: BinRefs) => void
}

type BinWrapperProps = ComponentPropsWithRef<'div'> & {
    vertical?: boolean
    className?: string
}

const BinContext = createContext<BinContextType>({
    selectedBinRef: null,
    onSelectBin: () => {},
})
export const useBinContext = () => useContext(BinContext)

export const BinsProvider = (p: BinWrapperProps & BinContextType) => {
    return (
        <BinContext.Provider
            value={{
                selectedBinRef: p.selectedBinRef,
                onSelectBin: p.onSelectBin,
            }}
        >
            <BinsLayer {...p} />
        </BinContext.Provider>
    )
}

export const BinsLayer = (p: BinWrapperProps) => {
    const { vertical = false } = p
    return (
        <div
            className={`flex justify-between ${p.className} text-sm gap-1 ${
                vertical ? 'flex-col' : 'flex-row'
            } `}
            style={{ direction: 'ltr' }} // arabic or not, keep this direction here
        >
            {p.children}
        </div>
    )
}
